var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30462 25.5H20.6954C22.5184 25.5 24 24.0139 24 22.1852V5.66664C24 3.83794 22.5184 2.35182 20.6954 2.35182H19.3846V1.42591C19.3846 0.916644 18.9692 0.5 18.4615 0.5C17.9538 0.5 17.5384 0.916644 17.5384 1.42591V2.35182H6.46157V1.42591C6.46157 0.916644 6.04613 0.5 5.53843 0.5C5.03073 0.5 4.61537 0.916644 4.61537 1.42591V2.35182H3.30462C1.48155 2.35182 0 3.83794 0 5.66664V22.1852C0 24.0139 1.48155 25.5 3.30462 25.5ZM1.8462 5.66664C1.8462 4.86111 2.50157 4.20371 3.30462 4.20371H4.61537V5.12962C4.61537 5.63889 5.03073 6.05553 5.53843 6.05553C6.04613 6.05553 6.46149 5.63889 6.46149 5.12962V4.20371H17.5384V5.12962C17.5384 5.63889 17.9538 6.05553 18.4615 6.05553C18.9692 6.05553 19.3846 5.63889 19.3846 5.12962V4.20371H20.6953C21.4984 4.20371 22.1537 4.86111 22.1537 5.66664V8.37038H1.8462V5.66664ZM22.1539 10.2222H1.8462V22.1852C1.8462 22.9907 2.50157 23.6481 3.30462 23.6481H20.6955C21.4985 23.6481 22.1539 22.9907 22.1539 22.1852V10.2222Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.9f725072f3c5c9e1b388d5b38998830e.svg";
export { ForwardRef as ReactComponent };